export default __webpack_public_path__ + "static/media/eggheaad.43291803.jfif";